/** Indicateur discret de l'état de l'auto-save (RG-SAIS-01). */

type SaveStatus = "idle" | "pending" | "saving" | "saved" | "error";

export function AutosaveIndicator({ status }: { status: SaveStatus }) {
  if (status === "idle") return null;
  const labels: Record<SaveStatus, string> = {
    idle: "",
    pending: "Modifications en attente…",
    saving: "Sauvegarde…",
    saved: "Sauvegardé",
    error: "Échec de la sauvegarde — vérifiez votre connexion",
  };
  const colors: Record<SaveStatus, string> = {
    idle: "text-gray-400",
    pending: "text-gray-500",
    saving: "text-blue-700",
    saved: "text-green-700",
    error: "text-red-700",
  };
  return (
    <p
      role="status"
      aria-live="polite"
      className={`text-xs ${colors[status]}`}
    >
      {labels[status]}
    </p>
  );
}
